<template>
  <div class="animated fadeIn">

    <b-card class="card-accent-info" header="Monitor">
      <b-card-body>
        <b-row>
          <b-col cols="auto">
            <b-form-group>
                <label for="company" style="font-size: 0.8em">Empresa</label>
                <b-form-select id="company"
                  v-model="filters.companyId"
                  :plain="true"
                  :options="companyDDL"
                  @change="changeCompany"
                  :value="[null,'c']">
                </b-form-select>
            </b-form-group>
          
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="inventory" style="font-size: 0.8em">Inventário {{ inventoryLabelEnd }}</label>
                <b-form-select id="inventory"
                  v-model="filters.inventoryId"
                  :plain="true"
                  :options="inventoryDDL"
                  :value="[null,'c']"
                  @change="changeInventory"
                  >
                </b-form-select>
            </b-form-group>
          
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="sector" style="font-size: 0.8em">Setor</label>
                <b-form-select id="sector"
                  v-model="filters.sectorId"
                  :plain="true"
                  :options="selectSectorDDL"
                  @change="refreshSector"
                  :value="[null,'c']">
              </b-form-select>
               
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Atualizar</span></b-button>
            </b-form-group>
          </b-col>

        </b-row>
      </b-card-body>
    </b-card>

    <b-row>
      <b-col sm="1" md="4" lg="3" v-for="item in monitor" :key="item.id">
          <b-card no-body :style="'background-color:' + item.color">
            <b-card-body class="pb-0">
            
              <p><span :style="'color: ' + item.fontColor">{{ item.title }}</span></p>
              <h1 class="mb-0 text-center"><span :style="'color: ' + item.fontColor">{{ item.quantity }}</span></h1>
              <b-progress height={} class="progress-xs my-3" :variant="item.progressBarVariant" :value="item.percentage"/>
              <h1 class="mb-0 text-center"><span :style="'color: ' + item.fontColor">{{ $utils.numberFormat(item.percentage,1) }} %</span></h1>
              <h4>&nbsp;</h4>
            </b-card-body>
            
          </b-card>
      </b-col>
    </b-row>

    <b-card class="card-accent-info" header="Etiquetas">
      <b-card-body>

        <b-row>
          <b-col cols="auto" class="mr-auto">
              <!--
              <b-form-group>
                  <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
            </b-form-group>
            -->
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group>
              <!--
              <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
              &nbsp;

              <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Etiqueta</span></b-button>
              -->
             
              <!--
              <b-button variant="github" class="mr-1 btn-brand" @click="openCancelModal()"><i class="fa fa-window-close-o"></i><span>Cancelar Etiqueta</span></b-button>
              -->

            </b-form-group>
          </b-col>
        </b-row>
      
        <b-row>
          <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Etiqueta</label>
                <b-form-input v-model="filters.label" type="text" id="labelFilter" placeholder="Etiqueta"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>

          <!--
          <b-col cols="auto">
            <b-form-group>
                <label for="productType" style="font-size: 0.8em">Tipo</label>
                <b-form-select id="productTypeId"
                  v-model="filters.productTypeId"
                  :plain="true"
                  :options="selectProductTypeDDL"
                  :value="[null,'c']">
                </b-form-select>

                {{ filters.productTypeId  }}
            </b-form-group>
          </b-col>
-->

          <b-col cols="auto">
            <b-form-group>
                <label for="status" style="font-size: 0.8em">Operação</label>
                <b-form-select id="operation"
                  v-model="filters.operationId"
                  :plain="true"
                  :options="selectOperationDDL"
                  :value="[null,'c']">
                </b-form-select>
            </b-form-group>
          </b-col>

      
          <b-col cols="auto">
            <b-form-group>
                <label for="inventoryProductStatus" style="font-size: 0.8em">Status</label>
                <b-form-select id="inventoryProductStatus"
                  v-model="filters.inventoryProductStatusId"
                  :plain="true"
                  :options="selectInventoryProductStatusDDL"
                  :value="[null,'c']">
                </b-form-select>
            </b-form-group>
          </b-col>

          <!--
        <b-col cols="auto">
            <b-form-group>
                <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                <b-form-select id="status"
                  v-model="filters.status"
                  :plain="true"
                  :options="statusddl"
                  :value="[null,'c']">
                </b-form-select>
            </b-form-group>
          </b-col>
-->
          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>

        <b-row class="mb-3">
          <b-col>
            <div class="d-flex align-items-center">
              <span class="text-muted">
                <strong>Total:</strong> {{ totalLabelsInventory }} etiquetas
                <span v-if="filteredItems.length !== items.length"> | <strong>Filtrados:</strong> {{ filteredItems.length }}</span>
              </span>
              <b-spinner small variant="primary" class="ml-2" v-if="isLoadingMore"></b-spinner>
              <span v-if="isLoadingMore" class="text-primary ml-1" style="font-size: 0.9em">Carregando mais...</span>
            </div>
          </b-col>
        </b-row>

          <b-table
              :items="filteredItems"
              :fields="fields"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              :primary-key="primaryKey"
              :tbody-transition-props="transProps"
              sort-icon-left
              @row-clicked="rowClicked"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              hover
              striped

              >

              <template #table-busy>
                  <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Carregando...</strong>
                  </div>
              </template>
              
              <!-- Example scoped slot for select state illustrative purposes -->
              <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                  </template>
              </template>

              <template #cell(show_details)="row">
                  <b-row>
                      <b-col cols="auto" class="mr-auto">
                          <b-form-group>
                          <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                          </b-form-group>
                      </b-col>
                  </b-row>
              </template>
              
              <template #row-details="row">
                  <b-card>
                      <b-row v-if="row.item.identificationUser">
                          <b-col class="small col-auto">Identificação: </b-col>
                          <b-col class="text-primary">[{{ row.item.identificationUser.username }}] {{ row.item.identificationUser.name }}</b-col>
                          <b-col class="small col-auto">Data: </b-col>
                          <b-col class="text-primary">{{ $utils.localDateTime(row.item.identificationDate) }}</b-col>
                          <b-col class="small col-auto">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b-col>
                          <b-col class="text-primary">&nbsp;&nbsp;&nbsp;</b-col>
                          
                      </b-row>
                      <b-row v-show="row.item.user1" v-if="row.item.user1">
                          <b-col class="small col-auto">1ª Contagem: </b-col>
                          <b-col class="text-primary">[{{ row.item.user1.username }}] {{ row.item.user1.name }}</b-col>
                          <b-col class="small col-auto">Data: </b-col>
                          <b-col class="text-primary">{{ $utils.localDateTime(row.item.count1Date) }}</b-col>
                          <b-col class="small col-auto">Quantidade: </b-col>
                          <b-col class="text-primary">{{ row.item.count1 }}</b-col>
                      </b-row>
                      <b-row v-show="row.item.user2" v-if="row.item.user2">
                          <b-col class="small col-auto">2ª Contagem: </b-col>
                          <b-col class="text-primary">[{{ row.item.user2.username }}] {{ row.item.user2.name }}</b-col>
                          <b-col class="small col-auto">Data: </b-col>
                          <b-col class="text-primary">{{ $utils.localDateTime(row.item.count2Date) }}</b-col>
                          <b-col class="small col-auto">Quantidade: </b-col>
                          <b-col class="text-primary">{{ row.item.count2 }}</b-col>

                      </b-row>
                      <b-row v-show="row.item.user3" v-if="row.item.user3">
                          <b-col class="small col-auto">3ª Contagem: </b-col>
                          <b-col class="text-primary">[{{ row.item.user3.username }}] {{ row.item.user3.name }}</b-col>
                          <b-col class="small col-auto">Data: </b-col>
                          <b-col class="text-primary">{{ $utils.localDateTime(row.item.count3Date) }}</b-col>
                          <b-col class="small col-auto">Quantidade: </b-col>
                          <b-col class="text-primary">{{ row.item.count3 }}</b-col>
                      </b-row>
                      
                  </b-card>
              </template>
              
              <template v-slot:cell(originalValue)="data">
                  {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
              </template>

              <template v-slot:cell(paymentValue)="data">
                  {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
              </template>

              <template v-slot:cell(productDetail)="data">
                
                  <div v-if="data.item.product">
                    {{ data.item.product.code  }}<br><span class="text-primary">{{ data.item.product.description }}</span>
                  </div>
                  
              </template>

              <template v-slot:cell(st)="data">
                  <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>
              
              <template v-slot:cell(ispublic)="data">
                  <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>

              <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="primary" @click="openEditModal(data.item)" class="mr-1 btn-brand" title="Editar" style="margin-bottom: 4px">
                    <i class="fa fa-edit"></i></b-button>
                    
              </template>
              
          </b-table>
          <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
          </nav>


      </b-card-body>
   </b-card>

   <b-modal
            v-model="cancelModal"
            id="cancel-modal"
            centered
            hide-footer
            title="Cancelar Etiqueta"
            size="lg">

      <b-card>

       
        <b-row>
          <b-col md="12">
            <b-form>
              <b-form-group
              description=""
              label="Etiqueta"
              label-for="label"
              :label-cols="3"
              :horizontal="true">
              <b-form-input v-model="selectedItem.label" id="label" type="text" style="text-transform: uppercase"></b-form-input>
            </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <b-input-group class="mb-4">
          <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
        </b-input-group>


        Observação: Somente etiquetas não identificadas poderão ser canceladas.

      
        <div slot="footer" class="text-right">
          <b-button variant="html5" class="mr-1 btn-brand" @click="closeCancelModal()"><i class="fa fa-window-close-o"></i><span>Fechar</span></b-button>
            <b-button variant="github" class="mr-1 btn-brand" @click="cancelLabel()"><i class="fa fa-window-close-o"></i><span>Cancelar Etiqueta</span></b-button>
        </div>
      </b-card>

   </b-modal>

   <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Etiqueta"
            size="lg">

            
        <b-nav fill>  
          <b-nav-item :active="tabInfo=='L'" @click="tabInfo='L'">Etiqueta</b-nav-item>
          <b-nav-item :active="tabInfo=='H'" @click="tabInfo='H'">Histórico</b-nav-item>            
        </b-nav>
        
        <div v-show="tabInfo=='H'">
          <b-card style="min-height: 300px">



            
            <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
            </b-input-group>
          
            <div slot="footer" class="text-right">
               <b-button variant="html5" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-close"></i><span>Fechar</span></b-button>
            </div>
            
          </b-card>
        </div>


        <div v-show="tabInfo=='L'">

          <b-card>

            <b-form @submit.stop.prevent="onSubmit">

              <div class="animated fadeIn">


            <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Etiqueta"
                      label-for="label"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.label" id="label" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>


                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Tipo"
                      label-for="typeName"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.product.typeName" id="typeName" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Código"
                      label-for="itemCode"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.product.code" id="itemCode" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Item"
                      label-for="itemDescription"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.product.description" id="itemDescription" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="U/M"
                      label-for="itemUM"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.product.umName" id="itemUM" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>



                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Setor"
                      label-for="sectorName"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.locationName" id="sectorName" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Operação"
                      label-for="operationCode"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.operationName" id="operationCode" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <hr>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Identificação"
                      label-for="idname"
                      :label-cols="3"
                      :horizontal="true">
                      <b-row>
                        <b-col><b-form-input v-model="selectedItem.identificationUser.name" id="idname" type="text"></b-form-input></b-col>
                        <b-col>{{ $utils.localDateTime(selectedItem.identificationDate) }}</b-col>
                      </b-row>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <hr>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="1ª Contagem"
                      label-for="count1"
                      :label-cols="3"
                      :horizontal="true">
                      <b-row>
                        <b-col><b-form-input v-model="selectedItem.count1" id="count1" type="number"  ></b-form-input></b-col>
                        <b-col><b-form-input v-model="selectedItem.user1.name" id="count1name" type="text"></b-form-input></b-col>
                        <b-col>{{ $utils.localDateTime(selectedItem.count1Date) }}</b-col>
                      </b-row>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="2ª Contagem"
                      label-for="count2"
                      :label-cols="3"
                      :horizontal="true">
                      <b-row>
                        <b-col><b-form-input v-model="selectedItem.count2" id="count2" type="number"  ></b-form-input></b-col>
                        <b-col><b-form-input v-model="selectedItem.user2.name" id="count2name" type="text"></b-form-input></b-col>
                        <b-col>{{ $utils.localDateTime(selectedItem.count2Date) }}</b-col>
                      </b-row>
                      
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="3ª Contagem"
                      label-for="count1"
                      :label-cols="3"
                      :horizontal="true">
                      <b-row>
                        <b-col><b-form-input v-model="selectedItem.count3" id="count3" type="number"  ></b-form-input></b-col>
                        <b-col><b-form-input v-model="selectedItem.user3.name" id="count3name" type="text"  ></b-form-input></b-col>
                        <b-col>{{ $utils.localDateTime(selectedItem.count3Date) }}</b-col>
                      </b-row>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>



                <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                </b-input-group>
              
                <div slot="footer" class="text-right">
                  <!--
                  <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                  <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Etiqueta</span></b-button>  
                -->
                  <b-button variant="html5" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-close"></i><span>Fechar</span></b-button>
                
                </div>
                      
              </div>
              </b-form>
              
          </b-card>
        </div>

     

    </b-modal>

  </div>

</template>

<script>
import Vue from 'vue'
import axios from "axios";

import { Switch as cSwitch } from '@coreui/vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

const newItem = {label: null, id: null, name: '', description: '', st: 'A', _rowVariant: '', identificationUser: { name: '', id: null}, user1: { name: '', id: null}, user2: { name: '', id: null}, user3: { name: '', id: null}, product: { typeName: null, typeId: null, code: null, umName: null, name: null, description: null}}

export default {
  name: 'tables',
  components: {
    Event,
    cSwitch
  },
  data: () => {
    return {
      intervalId: null,
      monitor: [],
      inventoryDDL: [],
      cancelModal: false,
      tabInfo: 'L',
      inventoryProductStatusDDL: [],
      productTypeDDL: [],
      sectorDDL: [],
      operationDDL: [],
      statusddl: [
        {
          text: '- Todos -',
          value: 0
        },
        {
          text: 'Ativo',
          value: 'A'
        },
        {
          text: 'Inativo',
          value: 'I'
        }
      ],
      companyDDL: [],

      isBusy: false,
      isLoadingMore: false,
      // Incrementado a cada refreshData(); usado para descartar respostas de
      // chamadas antigas quando o setor/filtro muda antes delas terminarem.
      refreshToken: 0,
      currentPage: 1,
      switchLabelIcon: {
          dataOn: '\u2713',
          dataOff: '\u2715'
      },
      switchLabelTxt: {
          dataOn: 'yes',
          dataOff: 'no'
      },

      tableRef: "table",
      tableSelectable: false,
      errorMessage: '',
      editModal: false,
      filters: {
        companyId: null,
        inventoryId: 0,
        key: '',
        status: 0,
        sectorId: 0,
        operationId: 0,
        productTypeId: 0,
        inventoryProductStatusId: 4,
        label: ''
      },

      modes: ['multi', 'single', 'range'],
      selectMode: 'multi',
      selected: [],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      primaryKey: "id",

      selectedItem: newItem,
      items: [        
      ],
      fields: [
        {key: 'show_details', label: "", thStyle: { width: "40px" } },
        //{key: 'id' },
        //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
        {key: 'label', label: 'Etiqueta', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        {key: 'product.typeName', label: 'Tipo', sortable: true, thStyle: { width: "150px" } },
        {key: 'productDetail', label: 'Item', sortable: true},
        {key: 'product.umName', label: 'U/M', sortable: true, class: 'text-center'},
        {key: 'locationName', label: 'Setor', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        {key: 'operationName', label: 'Op', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        {key: 'count1', label: '1ª Cont', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        {key: 'count2', label: '2ª Cont', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        {key: 'count3', label: '3ª Cont', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        {key: 'status.name', label: 'Status', sortable: true, thStyle: { width: "150px" }, class: 'text-center' },
        //{ key: 'action', label: '', sortable: false, thStyle: { width: "40px" } },
        //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
        //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
        //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
        //{key: 'description', label: 'Descrição', sortable: false },
        //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
        //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
        //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
      ],
      
      filterable: ['username'],
      sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
      perPage: 20
    }
  },
  computed: {
    inventoryLabelEnd() {

      try {
        var ret = this.inventoryDDL.find(item => item.value === this.filters.inventoryId).labelEnd
        return ret
      }
      catch {
        return "-"
      }


    },
    totalLabelsInventory() {
      try {
        var inv = this.inventoryDDL.find(item => item.value === this.filters.inventoryId)
        if(inv && inv.labelStart != null && inv.labelEnd != null) {
          return (inv.labelEnd - inv.labelStart) + 1
        }
        return 0
      }
      catch {
        return 0
      }
    },
    countBlank: function() {
      var total = 0
      if(this.items) {
        this.items.forEach(function(item) {
          if(item.status.code == 'BLANK') {
            total++;
          }
        })
      }
      return total
    },

    countCanceled: function() {
      var total = 0
      if(this.items) {
        this.items.forEach(function(item) {
          if(item.status.code == 'CANCEL') {
            total++;
          }
        })
      }
      return total
    },

    countTotal: function() {
      var total = 0
      if(this.items) {
        this.items.forEach(function(item) {
          if(item.status.code != 'CANCEL' && item.status.code != 'BLANK') {
            total++;
          }
        })
      }
      return total
    },

    count1: function() {
      var total = 0
      if(this.items) {
        this.items.forEach(function(item) {
          if(item.status.code != 'CANCEL' && item.status.code != 'BLANK' && item.count1) {
            total++;
          }
        })
      }
      return total
    },

    count2: function() {
      var total = 0
      if(this.items) {
        this.items.forEach(function(item) {
          if(item.status.code != 'CANCEL' && item.status.code != 'BLANK' && item.count2) {
            total++;
          }
        })
      }
      return total
    },

    count3: function() {
      var total = 0
      if(this.items) {
        this.items.forEach(function(item) {
          if(item.status.code == 'COUNT2') {
            total++;
          }
        })
      }
      return total
    },

    count3Total: function() {
      var total = 0
      if(this.items) {
        this.items.forEach(function(item) {
          if(item.status.code == 'COUNT3') {
            total++;
          }
        })
      }
      return total
    },

    selectInventoryProductStatusDDL: function() {
      var list = [...this.inventoryProductStatusDDL]
      list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Todos -' })
      return list
    },

    selectProductTypeDDL: function() {
      var list = [...this.productTypeDDL]
      list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Todos -' })
      return list
    },

    selectSectorDDL: function() {
      var list = [...this.sectorDDL]
      list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Todos -' })
      return list
    },

    selectOperationDDL: function() {
      var list = [...this.operationDDL]
      list = list.sort((a,b) => (Number(a.text) > Number(b.text)) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Todos -' })
      return list
    },

    totalRows: function () { return this.filteredItems.length },
    filteredItems() {
      try {
          var s = this
          return s.items.filter(item => {
            return (s.filters.key == '' || (
                  item.product && (
                  s.$utils.filterString(item.product.code, s.filters.key)
                  || s.$utils.filterString(item.product.description, s.filters.key)
                ) 
                  || (item.user1 && item.user1.username == s.filters.key )
                  || (item.user2 && item.user2.username == s.filters.key )
                  || (item.user3 && item.user3.username == s.filters.key )
                  || (item.identificationUser && item.identificationUser.username == s.filters.key )
                )
                //|| s.$utils.filterString(item.product.typeName, s.filters.key)
                //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                )
                && (s.filters.status==0 || (s.filters.status == 'A' || s.filters.status == 'I') && item.st == s.filters.status ) 
                && (s.filters.label == '' || (
                s.$utils.filterString(item.label, s.filters.label)
                ) )
                && (s.filters.sectorId==0 || (Number(s.filters.sectorId) == Number(item.locationId)))
                && (s.filters.operationId==0 || (Number(s.filters.operationId) == Number(item.operationId)))
                && (s.filters.inventoryProductStatusId==0 || (Number(s.filters.inventoryProductStatusId) == Number(item.status.id)))
          })
      }
      catch(e) {
          return this.items;
      }
    }
  },
  watch: {
    filteredItems() {
      var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
      if (this.currentPage > totalPages) {
        this.currentPage = 1;
      }
    },
    perPage() {
      var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
      if (this.currentPage > totalPages) {
        this.currentPage = 1;
      }
    }
  },
  methods: {

    percentage(total, value) {
      var per = 100 * value / total;
      return parseFloat(per).toFixed(1).toString().replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    changeStatus(item) {
      if(item != null) {
        if(item.st == 'A') 
          item.st = 'I'; 
        else 
          item.st = 'A';
        this.saveItem(item);
      }
    },

    cancelLabel() {
      let msgError = [];

      if(!this.selectedItem.label || this.selectedItem.label.length <= 0)
          msgError.push("Etiqueta");

      if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
              type: VueNotifications.types.error,
              title: 'Aviso',
              message: msgErrorExt,
              timeout: 5000
          })
      }
      else {
         // this.saveItem(this.selectedItem);
      }
    },

    async saveItem(currentItem) {

      var s = this;
      var postData = {...currentItem};

      postData["companyId"] = s.filters.companyId
      postData["uid"] = this.$store.state.currentUser.id,
      postData["sid"] = this.$store.state.currentUser.sid

      await axios.post(
          this.$store.state.ws_url + "/stock/location",
          postData
      ).then(function() {
          s.closeEditModal()
          s.refreshData();
      }
      ).catch(function (error) {
         // console.log(error);

          toast ({
              type: VueNotifications.types.warn,
              title: 'Erro',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
          })        
      });

  },

  save() {

      let msgError = [];

      if(this.selectedItem.name.length <= 2)
          msgError.push("Sigla");
      
      if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
              type: VueNotifications.types.error,
              title: 'Aviso',
              message: msgErrorExt,
              timeout: 5000
          })
      }
      else {
          this.saveItem(this.selectedItem);
      }
  },

    enableDisable() {
      console.log('Habilitando/desabilitando modelo')
      console.log(this.selectedItem);
    },

    closeCancelModal() {
      this.cancelModal = false
    },
    openCancelModal() {
      this.selectedItem = { ...newItem };
      this.cancelModal = true
    },

    closeEditModal() {
      this.editModal = false;
    },

    openEditModal(item) {
      if(item == null) {
          this.selectedItem = { ...newItem };      
      }
      else {
          this.selectedItem = { ...item };
      }

      if(!this.selectedItem.user1) {
        this.selectedItem.user1 = { id: null, name: null, username: null }
      }
      if(!this.selectedItem.user2) {
        this.selectedItem.user2 = { id: null, name: null, username: null }
      }
      if(!this.selectedItem.user3) {
        this.selectedItem.user3 = { id: null, name: null, username: null }
      }
      if(!this.selectedItem.product) {
        this.selectedItem.product = { typeName: null, typeId: null, code: null, umName: null, name: null, description: null }
      }

      this.editModal = true;
    },
    onRowSelected(items) {
      this.selected = items       
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelectedRows() {
      this.$refs.selectableTable.clearSelected();
    },
    rowClicked(item) {
          this.clearSelectedRows();
          this.openEditModal(item);
    },
    getBadge (status) {
      return status === 'A' ? 'primary'
          : status === 'I' ? 'danger'
          : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
    },
    async getSector() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        await axios.get(
          this.$store.state.ws_url + "/stock/location/label/ddl?inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.sectorDDL = resp.data.obj
            s.filters.sectorId = 0
            s.refreshData()
        })            
        .catch(function(error) {
            console.log(error);
        });
        
    },

    async getOperation() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/stock/operation/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
            s.operationDDL = resp.data.obj;
        })            
        .catch(function(error) {
            console.log(error);
        });
        
    }, 
    
    async getProductType() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/product/type/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
            s.productTypeDDL = resp.data.obj;
        })            
        .catch(function(error) {
            console.log(error);
        });
        
    }, 

    async getInventory() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          await axios.get(
              this.$store.state.ws_url + "/stock/inventory/ddl?companyId=" + s.filters.companyId + "&inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.inventoryDDL = resp.data.obj;

              if(s.inventoryDDL && s.inventoryDDL.length > 0) {
                if(!s.filters.inventoryId || s.filters.inventoryId <= 0 || !s.inventoryDDL.some(i => i.value == s.filters.inventoryId)) {
                  s.filters.inventoryId = Number(s.inventoryDDL[s.inventoryDDL.length-1].value)
                }
              }
              s.$utils.setInventoryContext(s.$store.state.config.storageName, s.filters.companyId, s.filters.inventoryId)
              s.getSector()
          })
          .catch(function(error) {
              console.log(error);
          });

      },

      

    async getInventoryProductStatus() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/inventory/product/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
            s.inventoryProductStatusDDL = resp.data.obj;
        })            
        .catch(function(error) {
            console.log(error);
        });
        
    }, 

    async refreshData() {

      // Identifica esta chamada; se o setor/filtro mudar de novo antes dela
      // terminar, uma nova chamada assume o token e esta é descartada.
      var myToken = ++this.refreshToken;

      this.refreshMonitor(myToken)

      var s = this;
      var currentUser = this.$store.state.currentUser;

      if (!(s.filters && s.filters.inventoryId)) {
        return;
      }

      if (!s.items || s.items.length <= 0) {
        s.isBusy = true;
      }
      this.isLoadingMore = false;

      var page = 0;
      var pageSize = 100;
      var allItems = [];
      var hasMoreData = true;

      while (hasMoreData) {
        if (myToken !== s.refreshToken) {
          // Uma chamada mais recente assumiu - abandona esta silenciosamente
          return;
        }

        var url = this.$store.state.ws_url + "/inventory/product?inventoryId=" + s.filters.inventoryId + "&stockLocationId=" + s.filters.sectorId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&page=" + page + "&pageSize=" + pageSize;
        try {
          var resp = await axios.get(url);

          if (myToken !== s.refreshToken) {
            return;
          }

          if (resp.data.obj && resp.data.obj.length > 0) {
            allItems = allItems.concat(resp.data.obj);

            // Substitui (não mescla) para refletir só o setor/filtro atual -
            // mergeArrays nunca removia itens de um setor trocado.
            s.items = [...allItems];

            // Remove o loading após carregar a primeira página
            if (page === 0) {
              s.isBusy = false;
              // Se há mais páginas, mostra o spinner de loading adicional
              if (resp.data.obj.length === pageSize) {
                s.isLoadingMore = true;
              }
            }

            // Se retornou menos itens que o pageSize, não há mais páginas
            if (resp.data.obj.length < pageSize) {
              hasMoreData = false;
            } else {
              page++;
            }
          } else {
            // Sem mais dados
            hasMoreData = false;
          }
        } catch (error) {
          hasMoreData = false;
          console.log(error.message);
        }
      }

      if (myToken === s.refreshToken) {
        this.isBusy = false;
        this.isLoadingMore = false;
      }
    },

      async refreshMonitor(token) {
        var s = this
        var currentUser = this.$store.state.currentUser

        if(currentUser && currentUser.id) {
          await axios.get(
            this.$store.state.ws_url + "/app/inventory/monitor?inventoryId=" + s.filters.inventoryId + "&stockLocationId=" + s.filters.sectorId + "&userId=" + currentUser.id
          ).then(function(resp) {
            if (token === undefined || token === s.refreshToken) {
              s.monitor = resp.data
            }
          }).catch(function(error) {
            console.log(error.message)
          })
        }

      },

      refreshSector() {
        this.items = []
        this.refreshData()
      },

      changeInventory() {
         this.$utils.setInventoryContext(this.$store.state.config.storageName, this.filters.companyId, this.filters.inventoryId)
         this.getSector()
      },

      changeCompany() {
        // Zera itens
        this.getOperation();
        this.getProductType();
        this.getInventoryProductStatus();
        this.getInventory();
      }

  },
  mounted: function() {
    this.companyDDL = this.$store.state.currentUser.companies

    var stored = this.$utils.getInventoryContext(this.$store.state.config.storageName)
    var validStoredCompany = stored && stored.companyId && this.companyDDL.some(c => c.value == stored.companyId)

    this.filters.companyId = validStoredCompany ? stored.companyId : this.$store.state.currentUser.companyId
    if(validStoredCompany && stored.inventoryId) {
      this.filters.inventoryId = stored.inventoryId
    }

    this.changeCompany()

    const refreshTime = this.$store.state.config.inventoryMonitorRefresh
    
    if(!this.intervalId) {
      this.intervalId = setInterval(this.refreshData, refreshTime ? refreshTime : 60000 )
    }   
  },
  beforeDestroy: function() {
    clearInterval(this.intervalId)
  }
}

</script>

<style scoped>
table#table-transition-example .flip-list-move {
transition: transform 1s;
}
</style>